import { useMemo } from 'react';

import { createTheme } from '@mui/material';
import { enUS as enUSDatagrid, nlNL as nlNLDatagrid } from '@mui/x-data-grid/locales';
import { enUS as enUSDatePickers, nlNL as nlNLDatePickers } from '@mui/x-date-pickers/locales';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import themeAtom from '~atoms/themeAtom';
import { ThemeEnum } from '~enums';
import { useSystemDarkTheme } from '~hooks';

import baseTheme from './baseTheme';
import darkTheme from './darkTheme';
import lightTheme from './lightTheme';

// const isSystemThemeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
const AppTheme = () => {
	const { i18n } = useTranslation();
	const theme = useAtomValue(themeAtom);
	const isSystemThemeDark = useSystemDarkTheme();

	return useMemo(
		() =>
			createTheme(
				(theme === ThemeEnum.System && isSystemThemeDark) || theme === ThemeEnum.Dark ?
					darkTheme
				:	lightTheme,
				baseTheme,
				i18n.resolvedLanguage === 'en' ? enUSDatePickers : nlNLDatePickers,
				i18n.resolvedLanguage === 'en' ? enUSDatagrid : nlNLDatagrid
			),
		[theme, isSystemThemeDark, i18n.resolvedLanguage]
	);
};

export default AppTheme;
